import { StyledBroadsiderPromoOption } from './BroadsiderPromoOption.styled';
import { openUrl } from '../../utils';

const BroadsiderPromoOption = ({ text, image, url, bigText }) => {
  return (
    <StyledBroadsiderPromoOption onClick={() => openUrl(url)}>
      {image ? (<img src={image} alt={bigText}/>) : (<div className='promo-big-text'>{bigText}</div>)}
      <div className='promo-desc'>{text}</div>
    </StyledBroadsiderPromoOption>
  );
};

export default BroadsiderPromoOption;
